// Sort direction
export const SORT_ASC = 'asc';
export const SORT_DESC = 'desc';

// Filter operators
export const FILTER_OPS = {
  textContains:    (v, q) => String(v).toLowerCase().includes(q.toLowerCase()),
  textBeginsWith:  (v, q) => String(v).toLowerCase().startsWith(q.toLowerCase()),
  textEndsWith:    (v, q) => String(v).toLowerCase().endsWith(q.toLowerCase()),
  textEquals:      (v, q) => String(v).toLowerCase() === q.toLowerCase(),
  numberEquals:    (v, q) => parseFloat(v) === parseFloat(q),
  numberGreater:   (v, q) => parseFloat(v) > parseFloat(q),
  numberLess:      (v, q) => parseFloat(v) < parseFloat(q),
  numberBetween:   (v, a, b) => parseFloat(v) >= parseFloat(a) && parseFloat(v) <= parseFloat(b),
  dateEquals:      (v, q) => new Date(v).toDateString() === new Date(q).toDateString(),
  dateToday:       (v) => new Date(v).toDateString() === new Date().toDateString(),
  dateThisMonth:   (v) => { const d = new Date(v); const n = new Date(); return d.getMonth() === n.getMonth() && d.getFullYear() === n.getFullYear(); },
};

export function sortRows(rows, col, dir = SORT_ASC) {
  return [...rows].sort((a, b) => {
    const va = (a[col] && a[col].value) || '';
    const vb = (b[col] && b[col].value) || '';
    const na = parseFloat(va), nb = parseFloat(vb);
    if (!isNaN(na) && !isNaN(nb)) {
      return dir === SORT_ASC ? na - nb : nb - na;
    }
    return dir === SORT_ASC
      ? String(va).localeCompare(String(vb))
      : String(vb).localeCompare(String(va));
  });
}

export function filterRows(rows, filters) {
  // filters: [{ col, op, value, value2 }]
  if (!filters || filters.length === 0) return rows;
  return rows.filter((row) => {
    return filters.every(f => {
      const cell = row[f.col];
      if (!cell) return true;
      const val = cell.value;
      const fn = FILTER_OPS[f.op];
      if (!fn) return true;
      if (f.op === 'numberBetween') return fn(val, f.value, f.value2);
      if (f.op === 'dateToday' || f.op === 'dateThisMonth') return fn(val);
      if (f.op === 'textContains' || f.op === 'textBeginsWith' || f.op === 'textEndsWith' || f.op === 'textEquals' || f.op === 'numberEquals' || f.op === 'numberGreater' || f.op === 'numberLess' || f.op === 'dateEquals') return fn(val, f.value);
      return true;
    });
  });
}
